/* eslint-disable */
import React from 'react';
import FilterBar from '../FilterBar';

// ============================================================
// DataFilterBar — the three Databases in the v3 grammar (S6). They are TabRouter
// tabs (lensBank · acetateBank · filesBank), not a PORTAL_NAV portal, so the bar
// gives them one identity — "Data" — with the Orders-style world switcher
// standing in for the drawer's three rows, always visible. Each page publishes
// its own sections, status, fields, search and actions through useShellBar; this
// bar merges that over the identity so the page stays the source of truth.
// ============================================================

export const DATA_WORLDS = [
  { key: 'lensBank',    label: 'Lens',    icon: 'eye',  title: 'Lens Database' },
  { key: 'acetateBank', label: 'Acetate', icon: 'db',   title: 'Acetate Database' },
  { key: 'filesBank',   label: 'Files',   icon: 'copy', title: 'Files Database' },
];
export const DATA_TABS = new Set(DATA_WORLDS.map((w) => w.key));

export default function DataFilterBar({ tab, setTab, published, condensed, chromeProps }) {
  const base = {
    portal: { key: 'data', name: 'Data', icon: 'db' },
    worlds: DATA_WORLDS,
    world: tab,
    onWorld: (k) => setTab(k),
    sections: [], section: null, onSection: () => {},
    status: [{ dot: 'live', text: 'Live' }],
    fields: [],
  };
  const cfg = published ? { ...base, ...published, portal: { ...base.portal, ...(published.portal || {}) } } : base;
  return <FilterBar cfg={cfg} condensed={condensed} {...chromeProps} />;
}
